module.exports = __webpack_public_path__ + "img/kids.945e025f.png";